module.exports = __webpack_public_path__ + "static/img/PL@2x.501fe526.jpg";